import { render, staticRenderFns } from "./editDocument.vue?vue&type=template&id=158d3396&scoped=true"
import script from "./editDocument.vue?vue&type=script&lang=js"
export * from "./editDocument.vue?vue&type=script&lang=js"
import style0 from "./editDocument.vue?vue&type=style&index=0&id=158d3396&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "158d3396",
  null
  
)

export default component.exports